import type { ImageProps } from 'next/image';

import gridBreakpoints from 'base/configs/grid.breakpoints';
import { getImageDimensions } from './getImageDimensions';
import { getImageUrl } from './getImageUrl';

export const getImageSrcSet = (src?: ImageProps['src'], maxWidth?: number): string | undefined => {
  const url = getImageUrl(src);
  const { width, height } = getImageDimensions(src);

  if (!url || !width || !height) {
    return undefined;
  }

  const screens = Object.values(gridBreakpoints).slice(1);
  const sets = [];

  if (maxWidth && maxWidth < screens[0]) {
    return undefined;
  }

  for (const screen of screens) {
    const scale = Math.min(screen, maxWidth || Infinity) / width;
    const src = new URL(url);

    src.searchParams.set('width', `${Math.round(width * Math.min(scale, 1))}`);
    src.searchParams.set('height', `${Math.round(height * Math.min(scale, 1))}`);

    sets.push(`${src} ${Math.min(screen, maxWidth || Infinity)}w`);

    if (screen > (maxWidth || Infinity)) {
      break;
    }
  }

  return sets.join(', ');
};
